<template>
  <div class="balancepay">
      <div class="balancepay_tit">
        充值中心
      </div>
      <div class="balancepay_box">
        <div class="balancepayitem" @click="balancefn(index,item)" :class="balanceid==index?'balanceactive':''" v-for="(item,index) in payarr">
           {{item}} 元
        </div>
        <div class="balancepayitem" @click="balancefn(5)"><input @blur.stop="inputmoney" v-model="moneyarr" placeholder="其他金额" type="text"></div>
      </div>
      <div class="balancepay_tit">
        选择充值方式
      </div>
      <div class="balancepay_box">
        <img src="../../../assets/pay.png" alt="" srcset="">微信支付
      </div>
      <div class="balancebtn" @click="balancebtn()">
          立即支付
      </div>
  </div>
</template>

<script>
  import {rechargeapi} from "../../../api/http.js"
export default {
  name: 'balancepay',
  components:{

  },
  data(){
    return{
      payarr:[
        10,20,50,100,200
      ],
      balanceid:0,
      money:"",
      moneyarr:""
    }
  },
  methods:{
    balancefn(index){
      this.balanceid = index
    },
    inputmoney(){
     let regnum = /^\+?[1-9][0-9]*$/
     regnum.test(this.moneyarr)? this.$message("输入正确"):this.$message("请输入正确的金额")
    },
   async balancebtn(){
     let regnum = /^\+?[1-9][0-9]*$/
      if(this.balanceid!=5){
          this.money =  this.payarr[this.balanceid]
      }else{
        this.money =  this.moneyarr
      }
      if(this.money === null || !regnum.test(this.money)){
         return this.$message("请输入正确的金额")
      }
      console.log(this.money);
      const res = await rechargeapi({money:this.money})
      if (res.data.code == 200) {
        this.$message(res.data.msg)
        this.$router.push({
          path:"/layout/balance"
        })
      } else{
        this.$message(res.data.msg)
      }
    }
  }
}
</script>

<style lang="less">
.balancepay{
  width: 100%;
  .balancepay_tit{
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    margin-bottom: 15px;
  }
  .balancepay_box{
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 28px 20px;
    border: 0.5px solid #CCCDCE;
    box-sizing: border-box;
    margin-bottom: 20px;
    img{
      width: 30px;
      height: 30px;
      margin-right: 15px;
    }
    .balanceactive{
      background: #FF4444;
      border: 2px solid #FF4444;
      color: #fff;
    }
    .balancepayitem{
      width: 83px;
      height: 32px;
      border: 1px solid #999999;
      margin-right: 25px;
      border-radius: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
      input{
        width: 100%;
        height: 100%;
        text-indent: 15px;
        outline: none;
        border: none;
        background-color: transparent;
      }
    }
  }
  .balancebtn{
    width: 136px;
    height: 40px;
    background: #FF4444;
    border-radius: 4px;
    font-weight: 400;
    font-size: 16px;
    line-height: 40px;
    color: #FFFFFF;
    text-align: center;
    margin-top: 40px;
    margin: 0 auto;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/view/balancepay.vue